export const PERPETUAL_ID = 'CANDLE_PERPETUAL';
export const PERPETUAL_CALENDAR_ID = 'CANDLE_PERPETUAL_CALENDAR';
export const PERPETUAL_HISTORICAL_ID = 'CANDLE_PERPETUAL_HISTORICAL';
export const CMVOL_SERIES_ID = 'CANDLE_CMVOL_SERIES';
export const CMVOL_SERIES_HISTORICAL_ID = 'CANDLE_CMVOL_SERIES_HISTORICAL';
